import { render, staticRenderFns } from "./SubscribeBox.vue?vue&type=template&id=4780e52a&scoped=true&"
import script from "./SubscribeBox.vue?vue&type=script&lang=js&"
export * from "./SubscribeBox.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeBox.vue?vue&type=style&index=0&id=4780e52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4780e52a",
  null
  
)

export default component.exports